import { Modal } from '@intigral/ui';
import TVODOverlayNoPortal from '../../../../components/elements/tvod/TVODOverlayNoPortal';
import { useMediaQuery } from '@intigral/hooks';
import QRCode from 'react-qr-code';
import { Button, FlexWrapper, FontIcon, Text } from '@intigral/shared';
import { FlexChild } from '@intigral/shared/components/FlexWrapper';
import h from '../../../../helpers/common';
import { __ } from '../../../../translations';
import { IPurchaseModalProps } from '../../types/iPurchase';

export const PurchaseModal: React.FC<IPurchaseModalProps> = ({
    showppvPurchaseOverlay,
    showppvQrModal,
    selectedPPVEvent,
    setShowppvPurchaseOverlay,
    onPurchaseSuccess,
    setShowppvQrModal,
}) => {
    const isMobile = useMediaQuery('(max-width: 924px)');
    return (
        <>
            {showppvPurchaseOverlay && (
                <TVODOverlayNoPortal
                    isOpen={showppvPurchaseOverlay}
                    onClose={() => setShowppvPurchaseOverlay(false)}
                    tvodInfo={{
                        priceWithVat: selectedPPVEvent?.price,
                        currency: selectedPPVEvent?.currency,
                    }}
                    isPPV={true}
                    eventData={selectedPPVEvent}
                    onPurchase={onPurchaseSuccess}
                />
            )}
            {showppvQrModal && (
                <Modal open={showppvQrModal} onOpenChange={setShowppvQrModal} closePlacement="null" widthSet="medium">
                    {isMobile ? (
                        <FlexWrapper flexDirection="column" justifyContent="center" gap="2x">
                            <FlexChild alignSelf="center">
                                <FontIcon name="mobile" size="x-large" />
                            </FlexChild>
                            <Text as="h3" variant="h5" margin="0">
                                {__('qr_code_modal_mobileview_title')}
                            </Text>
                            <Text as="p" variant="text5" color="gray">
                                {__('qr_code_modal_movileview_description')}
                            </Text>
                            <Button onClick={() => window.open(h.getOpenAppDeepLinkUrlPPV())} fullWidth>
                                {__('open_app_button_title')}
                            </Button>
                        </FlexWrapper>
                    ) : (
                        <FlexWrapper flexDirection="column" justifyContent="center" gap="2x">
                            <FlexChild alignSelf="center">
                                <QRCode
                                    id="QRCodeScaled"
                                    size={256}
                                    style={{
                                        height: 'auto',
                                        maxWidth: '100%',
                                        width: '100%',
                                        padding: 'calc(var(--step) * 3)',
                                        borderRadius: 'var(--step)',
                                        backgroundColor: '#fff',
                                    }}
                                    // title="Custom Title"
                                    value={h.getOpenAppDeepLinkUrlPPV()}
                                    viewBox={`0 0 256 256`}
                                />
                            </FlexChild>
                            <Text as="h3" variant="h5" margin="0">
                                {__('qr_code_modal_title')}
                            </Text>
                            <Text as="p" variant="text5" color="gray">
                                {__('qr_code_modal_description')}
                            </Text>
                            <Button onClick={() => setShowppvQrModal(!showppvQrModal)} fullWidth>
                                {__('devices_control_popup_button')}
                            </Button>
                        </FlexWrapper>
                    )}
                </Modal>
            )}
        </>
    );
};
